<template>
  <div>
        <div class="store-body">
            <div class="store-top">
                <div class="back" @click="back">
                    <i class="iconfont icon-left-01"></i>
                </div>
                <div class="storelist-name">
                    <p>参与企业列表</p>
                </div>
            </div>

            <div class="store-con">
                <ul v-if="$store.state.ACTIVITY_DATA_DETEIL.storeLen > 0">
                    <!--<li v-for="(item,index) in stores">-->

                        <!--<div  v-for="(item1,index1) in item" :class="(index1 < item.length-1) ? (item1.place ? 'box hide marR' : 'box marR'):(item1.place ? 'box hide':'box')" @click="selecte(item1)">-->
                            <!--<img :src="item1.imgUrl" v-if="item1.imgUrl">-->
                            <!--<span v-else-if="item1.poi && item1.poi.NAME">{{item1.poi.NAME}}</span>-->
                        <!--</div>-->

                    <!--</li>-->

                    <li v-for="(item,index) in $store.state.ACTIVITY_DATA_DETEIL.store" @click="selecte(item)">

                        <div class="box">
                            <img :src="item.imgUrl" v-if="item.imgUrl">
                            <span v-else>{{item.poi && item.poi.NAME ? item.poi.NAME :''}}</span>
                        </div>

                    </li>

                </ul>
            </div>
            <div class="line-end">
                <div class="fg"></div>
                <div class="font">我是有底线的</div>
                <div class="fg"></div>
            </div>
        </div>

        <Dialog class="brt-search-dialog-1" v-model="dialog1" title="选择操作方式" title-background>

          <div class="wrap-box">

              <div class="box l-box" @click="goPoint(seletItem)">
                  <div class="circle" bg="ye"><i class="iconfont icon-dianpu1"></i></div>
                  <p>查看企业信息</p>
              </div>
              <div class="box r-box" @click="goNaving">
                  <div class="circle" bg="gr"><i class="iconfont icon-daohang1"></i></div>
                  <p>导航前往</p>
              </div>

          </div>

      </Dialog>
  </div>
</template>

<script>
    import { Dialog } from '@/components/dialog';

export default {
  name: '',

  data () {
        return {
            seletItem:'',
            // stores:[],
            dialog1:false,
            Lastroute:'',
        }
      },

        created(){
            // this.stores = this.$store.state.ACTIVITY_DATA_DETEIL.storeALL;
        },

      methods: {



          back(){

              if(this.$BRT.lastRoute.match('/map')){

                  this.$router.replace('/details/2/'+this.$store.state.ACTIVITY_DATA_DETEIL.id);

              }else{

                  this.$router.replace(this.$BRT.lastRoute);
              }


          },
          selecte(item){
              this.seletItem = item;
              this.dialog1 = true;
          },

          goPoint(item){

              this.dialog1 = false;

              //店铺活动
              if(this.$BRT.$active.enterActiveDetail != 1){//详情页进入

                  if (this.$route.path.match('/details/1/')) {
                      this.$BRT.$active.enterActiveDetail = 3;
                  }

              }

              this.$BRT.$active.initEnter = this.$route.path;


              this.$router.replace('/map');

              this.$BRT.$filter.open = true;
              this.$BRT.$filter.initEnter = 'activeDetail';
              this.$mapStep.poiID = item.poi.POI_ID;
              this.$mapStep.type = 'selectePOI';
              //防止地图未加载
              if(this.$BRT.ready){
                  this.bus.$emit('selectedPoint', this.$mapStep.poiID);

              }else{  //地图未加载
                  this.$BRT.$urlParam.NomapReady = 1;//选点操作
              }
          },

          goNaving(){

              this.dialog1 = false;


              this.$router.replace('/map');
              this.$BRT.$selecte.endPoint = this.seletItem.poi;
              this.$BRT.$route.enterType='mainActive';
              this.$mapStep.type = 'planRoute';

              if(this.$BRT.ready){  //防止地图未加载
                  this.bus.$emit('startAndEnd',{type:2});
              }else{
                  this.$BRT.$urlParam.NomapReady = 2;//规划路径
              }

          }

      },
    components:{
        Dialog
    },

}
</script>

<style lang='less' scoped>
    @import "../../../../styles/cssBlock.less";
    @width:100%;
    .store-body{
        height: @width;
        overflow: scroll;
        .store-top{
            height: @90px;
            background-color: @themeReverseColor;
            padding: 0 @standartSpaceA3;
            display: flex;
            align-items: center;
            > .storelist-name{
                font-size: @fontSizeA4;
                color: @fontColorA1;
                flex: 1;
                text-align: center;

            }
            .back i{
                font-size: @30px;
            }

        }
        .store-con{
            //padding: @standartSpaceA4 @standartSpaceA3;
            //padding-bottom: calc(@standartSpaceA4 - @standartSpaceA2);
            background-color: @themeReverseColor;
            margin: @standartSpaceA3 0;
            overflow: hidden;

            > ul {

                clear: both;
                overflow: hidden;
                padding:@standartSpaceA3/2;

                li {

                    width: 33.33%;
                    float: left;
                    padding:@standartSpaceA3/2;

                    >.box{

                        .flexCenter();
                        width: 100%;
                        height: @90px;
                        border:1px solid @borderColorA2;

                        >span{
                            display: inline-block;
                            width: 100%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            padding: 0px 4px;
                            text-align: center;
                            color: @fontColorA2;
                        }

                        >img{
                            height: 100%;
                        }

                        &:active {
                            background-color: @activeBgColorA2
                        }
                    }

                    /*.flexCenter;

                    margin-bottom: @standartSpaceA3;

                    > .box {

                        position: relative;
                        flex: 1;
                        flex-shrink: 0;
                        height: @90px;
                        border: 1px solid @borderColorA2;
                        text-align: center;

                        overflow: hidden;

                        &.hide {
                            border: none;
                            pointer-events: none;
                        }

                        &.marR {
                            margin-right: @standartSpaceA3;
                        }
                        > img {
                            height: 100%;
                        }

                        > span {
                            .absoluteByCover;
                            text-align: center;
                            line-height: @90px;

                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-size: @fontSizeA6;
                            color: @fontColorA2;
                        }

                        &:active {
                            background-color: @activeBgColorA2
                        }
                    }*/

                    /*border: solid @borderColorA1 1px;
                    padding: @5px;
                     width: 30%;
                     margin-right: 5%;
                    float: left;
                   // height: @90px;
                    margin-bottom: @standartSpaceA2;
                    overflow: hidden;
                    text-align: center;
                    position: relative;
                      height: @95px;

                      &::before{
                        content: '';
                        display: block;
                        height: @95px;

                      }*/

                    /*img{*/

                    /*height: 100%;*/
                    /*position: absolute;*/
                    /*left: 0;*/
                    /*top: 0;*/
                    /*right: 0;*/
                    /*bottom: 0;*/
                    /*z-index: 10;*/
                    /*}*/

                }

            }

            /*li{

                .flexCenter;

                margin-bottom:@standartSpaceA3;

                >.box{
                    position: relative;
                    flex: 1;
                    flex-shrink: 0;
                    height: @90px;
                    border: 1px solid @borderColorA2;
                    text-align: center;
                    overflow: hidden;
                    cursor: pointer;
                    &.hide{
                        border: none;
                        pointer-events: none;
                    }

                    &.marR{
                        margin-right: @standartSpaceA3;
                    }
                    >img{
                        height: 100%;
                    }

                    >span{
                        .absoluteByCover;
                        text-align: center;
                        line-height:@90px;

                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: @fontSizeA6;
                        color: @fontColorA2;
                    }

                    &:active{background-color: @activeBgColorA2}
                }
            }*/


        }

        > .line-end{
            padding:0 @standartSpaceA3 @standartSpaceA3 @standartSpaceA3;
            display: flex;
            justify-content: center;
            color: @fontColorA3;
            font-size: @fontSizeA6;
            align-items:center;
            > .fg{
                width: 20%;
                height: 1px;
                background-color: @borderColorA2;
            }
            > .font{
                padding: 0 @standartSpaceA3;
            }

        }
    }

    .brt-dia-body{
        >.wrap-box{
            .flexCenter;
            padding: @60px;
            >.box{
                flex: 1;
                .flexCenter;
                flex-direction: column;

                &:active{opacity: .8}

                >.circle{
                    .flexCenter;

                    width: @standartWidthA1 * 1.2;
                    height: @standartWidthA1 * 1.2;
                    border-radius: @standartWidthA1 * 1.2/2;
                    color: @themeReverseColor;
                    background-color: @successColor;
                    margin-bottom: @standartSpaceA1;

                    &[bg='ye']{background-color: #ff9900}
                    >i{font-size: @fontSizeA1}
                }

                >p{text-align: center;font-size: @fontSizeA6;color: @fontColorA2}

            }
        }
    }
</style>


